import { Box, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import ResourceCalendar from "../../../components/calendar";
import GlobalButton from "../../../components/CustomButton";
import CategoryServiceFilterDialog from "../../../components/Dialog/CategoryServiceFilterDialog";
import Loader from "../../../components/Loader";
import NavigationDrawer from "../../../components/NavigationDrawer";
import SnackbarAlert from "../../../components/SnackBar";
import { setTabActive } from "../../../lib/slices/tabActiveSlice";
import { fetchAllEvents } from "../../../services/appointments";
import { convertAndCreateDate, formattedDate } from "../../../utils";
import CategoryDrawer from "./categoryDrawar";

function ClientCalendar() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const { user } = useSelector((state) => state.user);
  const [allEvents, setAllEvents] = useState([]);
  const openBlockTimeRef = useRef(null);
  const appointmentDialog = useRef(null);
  const openFilterDialog = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    handleFetchAllEvents();
  }, [isDrawerOpen, selectedBranch]);

  const handleFetchAllEvents = async () => {
    if (selectedBranch)
      try {
        setIsLoading(true);
        const responce = await fetchAllEvents(selectedBranch[0]);

        setIsLoading(false);
        if (responce.status == 200 || responce.status == 201) {
          let data = responce?.data?.data;
          let newArrr = data?.map((item) => {
            return {
              ...item,
              start: convertAndCreateDate(item?.start),
              end: convertAndCreateDate(item?.end),
            };
          });
          setAllEvents(newArrr);
        } else {
          handleSnackbarVal(true, "error", responce?.data?.message);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error, "error2134323");
        handleSnackbarVal(true, "error", error?.data?.message);
      }
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleOpenDrawer = () => {
    setIsDrawerOpen(false);
    dispatch(setTabActive(0));
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"Add Appointment"}
            styleProps={{
              height: 45,
              width: 150,
              fontWeight: 400,
              fontSize: "0.875rem",
            }}
            handleClickBtn={() => setIsDrawerOpen(true)}
          />
        </Box>
      </Stack>
    );
  };

  return (
    <NavigationDrawer>
      <AppContainer
        primaryHeading={`Today  ${formattedDate(new Date(), false)}`}
        secondaryHeading={"Calendar show all date and time"}
        headProps={renderRightPart()}
      >
        <ResourceCalendar
          allEvents={allEvents}
          setAllEvents={setAllEvents}
          handleFetchEvents={handleFetchAllEvents}
          openAppointmentDialog={appointmentDialog}
          openBlockTimeRef={openBlockTimeRef}
        />
      </AppContainer>

      {isDrawerOpen && (
        <CategoryDrawer
          onClose={handleOpenDrawer}
          setIsLoading={setIsLoading}
          handleSnackbarVal={handleSnackbarVal}
          setIsDrawerOpen={setIsDrawerOpen}
        />
      )}

      {/* <BookedAppointmentDialog ref={appointmentDialog} /> */}
      {/* <BlockedTimeDialog ref={openBlockTimeRef} /> */}
      <CategoryServiceFilterDialog ref={openFilterDialog} />
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </NavigationDrawer>
  );
}

export default ClientCalendar;
